module.exports = __webpack_public_path__ + "img/band-keshi.6b117b39.jpg";